import React, { useState } from 'react';
import Layout from '../../components/shared/Layout';
import { PageHeader, Card } from '../../components/shared/ui';

const steps = [
  {
    n: '01',
    icon: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0',
    title: 'Profilini Tamamla',
    desc: 'Üniversite, bölüm, beceriler, sertifikalar ve CTF platformlarını ekle. CV\'ni yükle. Profil ne kadar doluysa şirketler seni o kadar kolay buluyor.',
    color: 'bg-brand-50 text-brand-700',
    border: 'border-brand-200',
  },
  {
    n: '02',
    icon: 'M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z',
    title: 'Şirketler Seni İnceler',
    desc: 'Türkiye Siber Güvenlik Kümelenmesi üye şirketleri sisteme giriş yaparak profilleri inceler. Beceri, sertifika, şehir ve GPA gibi kriterlere göre seni filtreler.',
    color: 'bg-violet-50 text-violet-700',
    border: 'border-violet-200',
  },
  {
    n: '03',
    icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    title: 'Davet Alırsın',
    desc: 'Sana uygun bir şirket doğrudan davet gönderir. Bildirim alırsın. Daveti "Başvurularım" sayfasından görebilirsin.',
    color: 'bg-amber-50 text-amber-700',
    border: 'border-amber-200',
  },
  {
    n: '04',
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    title: 'Kabul Et ve Başla',
    desc: 'Daveti incele, şirketi araştır. Uygunsa kabul et. Şirket seninle iletişime geçerek staj sürecini başlatır.',
    color: 'bg-emerald-50 text-emerald-700',
    border: 'border-emerald-200',
  },
];

const faqs = [
  {
    q: 'İlan göremiyorum veya başvuru yapamıyorum, neden?',
    a: 'Bu tamamen kasıtlı bir tasarım. Platform "recruiter modeli" ile çalışıyor: sen başvuru yapmazsın, şirketler seni bulup davet eder. Yapman gereken tek şey profilini tamamlamak ve CV yüklemek.',
  },
  {
    q: 'Şirketler beni nasıl buluyor?',
    a: 'Şirketler ilan açarken beceri, sertifika, şehir, bölüm ve GPA gibi kriterleri belirler. Sistem profil bilgilerinle bu kriterleri karşılaştırarak seni uygun adaylar arasında gösterir. CV\'ni AI ile analiz ederek de ekstra puan alıyorsun.',
  },
  {
    q: 'Profil tamamlanma yüzdem neden %100 değil?',
    a: 'Profil tamamlanma şu 18 alanı kontrol ediyor: ad, soyad, telefon, şehir, üniversite, bölüm, sınıf, GPA, en az 1 beceri, en az 1 sertifika, hakkımda yazısı, LinkedIn, GitHub, iş deneyimi, proje, CTF platformu, CV dosyası ve dil. Eksik alanları "Profilim" sayfasından tamamlayabilirsin.',
  },
  {
    q: 'CV yüklemek neden önemli?',
    a: 'CV\'n sisteme yüklendikten sonra yapay zeka tarafından analiz ediliyor. Güçlü ve zayıf yönlerin çıkarılıyor, bir seviye (junior/mid/senior) atanıyor. Şirketler bu analizi görerek seni değerlendiriyor. CV\'siz profiller öne çıkmakta zorlanır.',
  },
  {
    q: 'Davet aldım, ne yapmalıyım?',
    a: '"Başvurularım" sayfasına git. Daveti gören şirketi ve ilgili ilanı incele. Uygunsa "Kabul Et" seçeneğini kullan. Şirket daha sonra seninle doğrudan iletişime geçer. Uymuyorsa reddetmekte özgürsün.',
  },
  {
    q: 'Birden fazla şirketten davet alabilir miyim?',
    a: 'Evet. Aynı anda birden fazla şirketten davet alabilirsin. Hepsini "Başvurularım" sayfasından takip edebilirsin. Birini kabul etsen bile diğer süreçler devam eder — şirketlerle iletişimde açık ve dürüst olman tavsiye edilir.',
  },
  {
    q: 'Hangi şirketler bu platformda var?',
    a: 'Yalnızca Türkiye Siber Güvenlik Kümelenmesi üyesi şirketler platforma katılabiliyor. Kümeleme, şirketleri onaylıyor ve doğruluyor. Bu nedenle burada karşılaşacağın şirketlerin güvenilirliği garanti altında.',
  },
  {
    q: 'Staj zorunlu mu gönüllü mü?',
    a: 'İkisi de olabilir. İlanlar "Zorunlu Staj", "Gönüllü Staj" veya "Her ikisi" olarak işaretleniyor. Profilinde tercihini belirtebilirsin; sistem bu tercihe göre de eşleştiriyor.',
  },
  {
    q: 'Şehrim önemli mi?',
    a: 'Evet. Eşleştirme skorunda şehir uyumu %15 ağırlık taşıyor. Profildeki şehrini güncel tut. Uzaktan (remote) staj ilanlarında şehir fark etmiyor.',
  },
  {
    q: 'Staj bittikten sonra ne yapabilirim?',
    a: 'Staj tamamlandıktan sonra "Başvurularım" sayfasından ilgili başvuruya değerlendirme bırakabilirsin. Değerlendirmen anonim olarak yayınlanabilir ve gelecekteki öğrencilere yol gösterir.',
  },
];

const Icon = ({ d }) => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-xl overflow-hidden transition-colors ${open ? 'border-brand-200 bg-brand-50/30' : 'border-ink-200 bg-white'}`}>
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left"
      >
        <span className={`text-sm font-semibold leading-snug ${open ? 'text-brand-800' : 'text-ink-900'}`}>{q}</span>
        <span className={`mt-0.5 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180 text-brand-600' : 'text-ink-400'}`}>
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-5 pb-5">
          <p className="text-sm text-ink-600 leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
};

const StudentFAQ = () => (
  <Layout>
    <PageHeader
      title="Nasıl Çalışır?"
      description="Platforma yeni katıldıysan buradan başla. Sistem nasıl işliyor, ne yapman gerekiyor."
    />

    {/* Adımlar */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
      {steps.map((s) => (
        <Card key={s.n} className={`border ${s.border} !p-5`}>
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${s.color}`}>
              <Icon d={s.icon} />
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-[11px] font-bold text-ink-400 tracking-widest">{s.n}</span>
                <span className="text-sm font-bold text-ink-900">{s.title}</span>
              </div>
              <p className="text-sm text-ink-600 leading-relaxed">{s.desc}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>

    {/* Profil ipucu banner */}
    <div className="rounded-xl border border-amber-200 bg-amber-50 px-5 py-4 mb-8 flex items-start gap-3">
      <svg className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div>
        <div className="text-sm font-semibold text-amber-900 mb-0.5">En önemli ipucu</div>
        <p className="text-sm text-amber-800 leading-relaxed">
          Şirketler sadece <strong>aktif ve profili tamamlanmış</strong> öğrencileri görüyor.
          Profil tamamlanma yüzden ne kadar yüksekse, eşleşme şansın o kadar artıyor.
          CV yüklemek hem skorunu yükseltiyor hem de AI analizi sayesinde şirketlere daha fazla bilgi sunuyor.
        </p>
      </div>
    </div>

    {/* SSS */}
    <h2 className="text-base font-bold text-ink-900 mb-4">Sık Sorulan Sorular</h2>
    <div className="flex flex-col gap-2">
      {faqs.map((f, i) => (
        <FaqItem key={i} q={f.q} a={f.a} />
      ))}
    </div>

    {/* Alt destek notu */}
    <div className="mt-8 rounded-xl border border-ink-200 bg-white px-5 py-4 flex items-start gap-3">
      <svg className="w-5 h-5 text-ink-400 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <p className="text-sm text-ink-600 leading-relaxed">
        Aklına takılan başka bir şey mi var? Türkiye Siber Güvenlik Kümelenmesi ile iletişime geçebilirsin.
      </p>
    </div>
  </Layout>
);

export default StudentFAQ;
